module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Histogram.js"));
	}, "Histogram");
}